import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useAtomValue } from 'jotai';
import {
  NotFoundWithSuggestions,
} from '../../NotFound';
import { ErrorBoundary } from '../../ErrorBoundary';
import { useRobotNoIndex } from '../../useRobotNoIndex';
import {
  ValidSections, VALID_SECTIONS, pathnameUrlLanguageAtom, pathnameRawUrlSectionAtom,
} from '../../../history';
import { VALID_SECTION_LABELS } from './labels';

export const SectionNotFound = () => {
  useRobotNoIndex();
  const param = useAtomValue(pathnameRawUrlSectionAtom);
  const sections = VALID_SECTIONS.filter((section) => section !== ValidSections.UPLOAD && section !== ValidSections.ORDER);
  const language = useAtomValue(pathnameUrlLanguageAtom);
  const baseTo = `/${language}`;
  return (
    <ErrorBoundary>
      <NotFoundWithSuggestions
        param={param}
        whiteListedSections={sections}
        labelMap={VALID_SECTION_LABELS}
        baseTo={baseTo}
        color={ouiStyle.Constants.Colors.greyDarkest}
      />
    </ErrorBoundary>
  );
};
